import { getCashSessionSummary } from '@/api/cash_management';
import { useQuery } from '@tanstack/react-query';

type UseGetCashSessionSummaryParams = {
  id?: string;
  enabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onError?: (error: unknown) => void;
};

export function useGetCashSessionSummary({
  id,
  enabled = true,
  onError,
}: UseGetCashSessionSummaryParams) {
  return useQuery({
    queryKey: ['cash-session-summary', id],
    queryFn: () => getCashSessionSummary(id || ''),
    enabled: !!id && enabled,
    staleTime: 1000 * 60 * 1,
    onError,
  });
}
